import(/* webpackMode: "eager", webpackExports: ["Team"] */ "/vercel/path0/frontend_next/src/screens/user/Team.tsx");
